<!-- eslint-disable quotes -->
<template>
  <div>
    <base-nav v-show="showNavbar" container-classes="container-fluid" class="navbar-top border-bottom navbar-expand" :class="{ 'bg-success navbar-dark': type === 'default' }">
      <!-- Search form -->
      <!-- <b-form
        class="navbar-search form-inline mr-sm-3"
        :class="{
          'navbar-search-light': type === 'default',
          'navbar-search-dark': type === 'light'
        }"
        id="navbar-search-main"
      >
        <b-form-group v-show="false" class="mb-0">
          <b-input-group class="input-group-alternative input-group-merge">
            <div class="input-group-prepend">
              <span class="input-group-text">
              <i class="fas fa-search"></i>
              </span>
            </div>
            <b-form-input placeholder="buscar" type="text"> </b-form-input>
          </b-input-group>
        </b-form-group>
        <button
          type="button"
          class="close"
          data-action="search-close"
          data-target="#navbar-search-main"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </button>
      </b-form>-->

      <!-- Navbar links -->
      <b-navbar-nav v-show="showNavbar" class="align-items-center text-left">
        <!-- This item dont have <b-nav-item> because they add class 'nav-link' which is not needed here -->
        <li class="nav-item d-xl-none">
          <!-- Sidenav toggler -->
          <div @click="toggleSidebar" :class="{ active: $sidebar.showSidebar, 'sidenav-toggler-dark': type === 'default', 'sidenav-toggler-light': type === 'light', }"
            class="pr-3 sidenav-toggler">
            <div class="sidenav-toggler-inner">
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
              <i class="sidenav-toggler-line"></i>
            </div>
          </div>
        </li>
        <!-- This item dont have <b-nav-item> because item have data-action/data-target on tag <a>, wich we cant add -->
        <!-- <li class="nav-item d-sm-none">
          <a
            class="nav-link"
            href="#"
            data-action="search-show"
            data-target="#navbar-search-main"
          >
            <i class="ni ni-zoom-split-in"></i>
          </a>
        </li>-->
      </b-navbar-nav>

      <!-- Ícone notificação -->
      <div class="notification text-right">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 6.66602C15 5.33993 14.4732 4.06816 13.5355 3.13048C12.5979 2.1928 11.3261 1.66602 10 1.66602C8.67392 1.66602 7.40215 2.1928 6.46447 3.13048C5.52678 4.06816 5 5.33993 5 6.66602C5 12.4993 2.5 14.166 2.5 14.166H17.5C17.5 14.166 15 12.4993 15 6.66602Z"
            stroke="#146782" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" />

          <path d="M11.4417 17.5C11.2952 17.7526 11.0849 17.9622 10.8319 18.1079C10.5789 18.2537 10.292 18.3304 10 18.3304C9.70803 18.3304 9.42117 18.2537 9.16816 18.1079C8.91515 17.9622 8.70486 17.7526 8.55835 17.5"
            stroke="#146782" stroke-width="2.33333" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>

      <!-- Ícone configurações -->
      <b-nav class="align-items-center pl-0 mr-3" style="margin-left:auto">
        <base-dropdown menu-on-right class="nav-item" tag="li" title-tag="a" title-classes="nav-link pr-0">
          <a href="#" class="nav-link pr-0 pl-0" @click.prevent slot="title-container">
            <span aria-hidden="true" class="avatar avatar-sm rounded-circle text-black">
              <i class="no no-sm no-cogwheel-3" aria-hidden="true"></i>
            </span>
          </a>

          <template>
            <b-dropdown-item @click="softResetPassword">Redefinir senha</b-dropdown-item>
          </template>
        </base-dropdown>
      </b-nav>

      <div class="verticalLine mr-2">
      </div>

      <div class="text-right mr-2">
        <span class="avatar avatar-sm rounded-circle text-black">
          <span aria-hidden="true">
            <i class="fa fa-fingerprint" aria-hidden="true"></i>
          </span>
        </span>
      </div>

      <!--   <b-nav class="align-items-center pl-0 mr-3">
        <base-dropdown
          menu-on-right
          class="nav-item"
          tag="li"
          title-tag="a"
          title-classes="nav-link pr-0"
        >
          <a
            href="#"
            class="nav-link pr-0 pl-0"
            @click.prevent
            slot="title-container"
          >
            <b-media no-body class="align-items-center">
              <span class="avatar avatar-sm rounded-circle text-black">-->
      <!-- <img alt="Image placeholder" src="img/theme/biometric-icon-21.jpg" /> -->
      <!-- <span aria-hidden="true"
                  ><i class="fa fa-fingerprint" aria-hidden="true"></i
                ></span>
              </span>
            </b-media>
          </a>

          <template>
            <b-dropdown-header>
              {{ user.name }}
            </b-dropdown-header>
            <div v-for="(role, index) in dropDownHeadersItens" :key="index">
              <b-dropdown-item href="">
                <i class="ni ni-calendar-grid-58"></i>
                <span>{{ role.name }}</span>
              </b-dropdown-item>
            </div>
            <div class="dropdown-divider"></div>
            <b-dropdown-item @click="logout">
              <i class="ni ni-user-run"></i>
              <span>Sair</span>
            </b-dropdown-item>
          </template>
        </base-dropdown>
      </b-navbar-nav> -->
      <div class="text-right mr-3 text-black">
        {{ welcomeMessage() }}
      </div>

      <!-- Ícone Sign Out -->
      <div class="align-items-center pl-0 mr-3">
        <a href="#" class="nav-link pr-0 pl-0" @click.prevent>
          <b-media no-body class="align-items-center">
            <span class="logout" @click="logout">
              <span aria-hidden="true"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.5 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5"
                    stroke="#146782" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />

                  <path d="M13.3334 14.1673L17.5 10.0007L13.3334 5.83398" stroke="#146782" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />

                  <path d="M17.5 10H7.5" stroke="#146782" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" />
                </svg>
              </span>
            </span>
          </b-media>
        </a>
      </div>
    </base-nav>

    <b-modal v-if="openResetPasswordModal" v-model="openResetPasswordModal" no-close-on-backdrop hide-footer no-close-on-esc size="xl" modal-tall>
      <template #modal-header style="padding: 0; margin: 0;">
        <div class="d-flex w-100 border-bottom pb-0">
          <h2 align-v="start" class="w-100 text-left pb-2">
            Redefinir Senha
          </h2>

          <div class="text-right pb-0">
            <button @click.prevent="closeResetPasswordModal()" type="button" class="close" aria-label="Fechar">
              <span @click.prevent="closeResetPasswordModal()" class="no no-e-remove"></span>
            </button>
          </div>
        </div>
      </template>

      <div style="padding: 0%;">
        <ResetPassword :onModal="openResetPasswordModal" @closeResetPasswordModal="closeResetPasswordModal"></ResetPassword>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import { CollapseTransition } from "vue2-transitions";
import { BaseNav } from '@/components'
import ResetPassword from '../Pages/ResetPassword.vue'
import { mapActions, mapGetters } from 'vuex'
import swal from 'sweetalert2'

export default {
  components: {
    // CollapseTransition,
    BaseNav,
    // Modal
    ResetPassword,
  },

  props: {
    type: {
      type: String,
      default: 'light', // default|light
      description: 'Look of the dashboard navbar. Default (Green) or light (gray)',
    },
  },

  computed: {
    ...mapGetters('auth', {
      user: 'user',
      roles: 'roles',
    }),

    routeName() {
      const { name } = this.$route
      return this.capitalizeFirstLetter(name)
    },
  },

  data() {
    return {
      activeNotifications: false, showNavbar: true, dropDownHeadersItens: [],
      searchModalVisible: false, openResetPasswordModal: false,
      bcClasses: '', searchQuery: '',
    }
  },

  created() {
    if (window.location.href.indexOf('janoo.com.br') > 0 || this.$route.query.hosted == 'janoo') {
      this.bcClasses += 'janoo_hosteded '
    }
  },

  mounted() {
    this.handleHolesItensDropDown()
    if (!this.$sidebar.isMinimized) {
      this.$sidebar.toggleMinimize()
    }
  },

  methods: {
    ...mapActions('auth', [
      // 'loginRequest',
      'logoutRequest',
    ]),

    ...mapActions('login', [
      'forgotPassword',
    ]),

    ...mapActions('report', [
      'reportStoreCommit',
    ]),

    ...mapActions('product', [
      'resetChartsCache',
    ]),

    handleHolesItensDropDown() {
      for (var k in this.roles) {
        this.dropDownHeadersItens = this.roles[k].filter((element) => {
          return element.visible === 'profile-menu'
        })
      }
    },

    async logout(path) {
      if (!path || typeof path != 'string') {
        path = '/login'
      }

      await this.resetChartsCache()
      this.logoutRequest()
        .then(() => {
          let bc_version = localStorage.getItem('bc_version')
          localStorage.clear()
          sessionStorage.clear()
          localStorage.setItem('bc_version', bc_version)
          // this.$router.push({ path: path, }).catch()
          window.location.reload(true)
        })
    },

    async softResetPassword() {
      const email = this.user.email
      const phone_number = this.user.phone
      const message = `Você receberá o código de recuperação de senha no email ${email}.`

      swal.fire({
        title: 'Deseja redefinir sua senha?',
        text: message,
        buttonsStyling: false,
        showCancelButton: true,
        reverseButtons: true,
        confirmButtonText: 'Redefinir',
        confirmButtonClass: 'btn btn-success',
        cancelButtonText: 'Cancelar',
        cancelButtonClass: 'btn btn-primary',
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.forgotPassword(email)
          this.openResetPasswordModal = true
        }
      })
    },
 
    closeResetPasswordModal(){ this.openResetPasswordModal = false },

    capitalizeFirstLetter(string) { return string.charAt(0).toUpperCase() + string.slice(1) },

    toggleNotificationDropDown() { this.activeNotifications = !this.activeNotifications },

    closeDropDown() { this.activeNotifications = false },

    toggleSidebar() { this.$sidebar.displaySidebar(!this.$sidebar.showSidebar) },

    hideSidebar() { this.$sidebar.displaySidebar(false) },

    welcomeMessage() { return `${ this.user.name || ''}` },

  },
}
</script>

<style>
.verticalLine {
  border-left: solid #eaeaea;
  height: 30px;
}

@media screen and (max-width: 768px) {
  .notification {
    display: none;
  }
}
</style>
